import React, { useEffect, useState } from "react";
import { Topbar } from "@components";
import {
  RootContainer,
  RefreshIcon,
  ImageWrapper,
  TopContainer,
  BackgroundImage,
  TopTitle,
  TopWrapper,
  BalanceText,
  LightTextLabel,
  LightText,
  LabelWrapper,
  ActionsWrapper,
  ActionButton,
  ActionLabel,
  BottomBar,
  ListTitle,
  ListContainer,
  EmptyText,
  ListItem,
  ItemImage,
  Wrapper,
  ItemText,
  DateText,
  AmountText,
  StatusText,
  SpinImage,
  BonusImage,
  ExpiredText,
  ExpiredLabel,
  BonusStatusText,
  DataWrapper,
} from "./Wallet.style";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE, PRIVATE_ROUTE } from "@router/route.constants";
import {
  TOPUP_LK,
  WITHDRAW_SK,
  BONUS_SK,
  SPIN_BONUS_SK,
} from "@constants";
import { useDispatch, useSelector } from "react-redux";
import { getFormattedNumber, localStorage } from "@utils";
import { api } from "@api";
import { saveUser } from "@redux/auth/authSlice";
import { useTranslation } from "react-i18next";
import { Badge, Spin } from "antd";
import {
  TopUpOutlined,
  WithdrawOutlined,
  BalanceLoading,
} from '@assets';
import { ContainerOutlined } from '@ant-design/icons';
import moment from "moment";
import { getStatus } from "@utils";
import Lottie from "react-lottie";

const dateFormat = "MMM DD, YYYY hh:mm:ss A";

export const BonusImg = ({ type }) => (
  <ImageWrapper>
    {type === SPIN_BONUS_SK
      ? <SpinImage />
      : <BonusImage />
    }
  </ImageWrapper>
);

const Wallet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { main_balance, bonus, is_in_game } = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    getRecentHistory();

    // eslint-disable-next-line
  }, []);

  const getRecentHistory = () => {
    setLoading(true);
    api
      .getRecentHistory()
      .then(({ transactions, user }) => {
        setLoading(false);
        setData(transactions);

        // Save user to redux
        dispatch(saveUser(user));
        // Set user to localstorage
        localStorage.setUser(user);
      })
      .catch((error) => { });
  };

  const goToHome = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}`);
  };

  const goToTransactions = () => {
    navigate(`/${PRIVATE_ROUTE.TRANSACTIONS}`);
  };

  const handleTopUpClicked = () => {
    navigate(`/${PRIVATE_ROUTE.ACCOUNT_TYPE}/${TOPUP_LK}`);
  };

  const handleWithdrawClicked = () => {
    navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`);
  };

  const refresh = () => {
    window.location.reload();
  };

  const renderTop = () => (
    <TopContainer>
      <BackgroundImage />
      <TopWrapper>
        <TopTitle>{t("wallet.walletTotalBalance")}</TopTitle>
        <BalanceText>
          {is_in_game
            ? <Lottie
              options={{
                animationData: BalanceLoading,
              }}
              height={36}
            />
            : `${getFormattedNumber(main_balance + bonus)} Ks`
          }
        </BalanceText>
        <div>
          <LabelWrapper>
            <Badge color="yellow" />
            <LightTextLabel>{t("wallet.actualTopupLabel")}</LightTextLabel>
            <LightText>{`${is_in_game ? '-' : getFormattedNumber(main_balance)} Ks`}</LightText>
          </LabelWrapper>
          <LabelWrapper>
            <Badge color="yellow" />
            <LightTextLabel>{t("wallet.bonusLabel")}</LightTextLabel>
            <LightText>{`${is_in_game ? '-' : getFormattedNumber(bonus)} Ks`}</LightText>
          </LabelWrapper>
        </div>

        <ActionsWrapper>
          <ActionButton onClick={handleTopUpClicked}>
            <ActionLabel>
              {t("wallet.walletTopUp")}
            </ActionLabel>
            <TopUpOutlined />
          </ActionButton>

          <ActionButton onClick={handleWithdrawClicked}>
            <ActionLabel>
              {t("wallet.walletWithdraw")}
            </ActionLabel>
            <WithdrawOutlined />
          </ActionButton>
        </ActionsWrapper>

      </TopWrapper>
    </TopContainer>
  );

  const renderBottom = () => (
    <BottomBar onClick={goToTransactions}>
      {t("wallet.walletSeeAll")}
    </BottomBar>
  );

  const Loader = () => (
    <div className="loader">
      <Spin />
    </div>
  );

  const EmptyCard = () => (
    <div className="empty-box">
      <ContainerOutlined />
      <EmptyText>
        {t("common.noRecord")}
      </EmptyText>
    </div>
  );

  const List = () => (
    <>
      <ListTitle>{t("wallet.walletRecentHistory")}</ListTitle>
      <ListContainer>
        {data.map((item, key) => (
          <ListItem key={key}>
            {item.type === BONUS_SK
              ? <BonusImg type={item.bonus_type} />
              : <ItemImage src={item.payment_category_image} />
            }
            <DataWrapper>
              <Wrapper>
                <ItemText>
                  {item.type === BONUS_SK
                    ? t("wallet.transactionHistoryBonusType", {
                      bonus_type: item.bonus_type.replaceAll('-bonus',''),
                    })
                    : `${item.type === WITHDRAW_SK
                      ? t("wallet.walletWithdraw")
                      : t("wallet.walletTopUp")
                    } ${t("common.to")} ${item.num}`}
                </ItemText>
                <AmountText>
                  {`${getFormattedNumber(item.amount)} Ks.`}
                </AmountText>
              </Wrapper>
              <Wrapper>
                <DateText>
                  {moment.unix(item.created_at).format(dateFormat)}
                </DateText>
                {item.type === BONUS_SK && item.bonus_expired && (
                  <BonusStatusText status={item.status}>
                    {item.status === 'Used'
                      ? t("wallet.bonusUsedText")
                      : t("wallet.bonusNotUsedText")
                    }
                  </BonusStatusText>
                )}
                {item.type !== BONUS_SK && (
                  <StatusText status={item.status}>
                    {getStatus(item.status)}
                  </StatusText>
                )}
              </Wrapper>
              <Wrapper>
                {item.trx_num &&
                  <DateText>
                    {`PIN: ${item.trx_num}`}
                  </DateText>
                }
                {item.type === BONUS_SK && item.bonus_expired &&
                  <div style={{ display: "flex" }}>
                    <ExpiredLabel>{t("wallet.expiredLabel")}</ExpiredLabel>
                    <ExpiredText>&nbsp;&nbsp;
                      {moment.unix(item.bonus_expired).format(dateFormat)}
                    </ExpiredText>
                  </div>
                }

              </Wrapper>
            </DataWrapper>

          </ListItem>
        ))}
        {loading && <Loader />}
        {!loading && data.length === 0 && <EmptyCard />}
      </ListContainer>
    </>
  );

  return (
    <RootContainer>
      <Topbar
        title={t("wallet.walletTitle")}
        shadow={false}
        rightIcon={<RefreshIcon onClick={refresh} />}
        goBack={goToHome}
      />
      {renderTop()}
      <List />
      {renderBottom()}
    </RootContainer>
  );
};

export default Wallet;
